var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_791",
    "data-name": "Group 791",
    transform: "translate(-1023.854 -993.267)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_279",
    "data-name": "Rectangle 279",
    width: 30,
    height: 30,
    rx: 4,
    transform: "translate(1024.354 993.767)",
    fill: "none",
    stroke: "#b7b5b6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M14.261,17.23a4.183,4.183,0,1,0-2.977-1.224,4.044,4.044,0,0,0,2.977,1.224M14.253,15.8a2.656,2.656,0,0,1-1.959-.81,2.685,2.685,0,0,1-.8-1.965,2.656,2.656,0,0,1,.81-1.959,2.685,2.685,0,0,1,1.965-.8,2.656,2.656,0,0,1,1.959.81,2.685,2.685,0,0,1,.8,1.965A2.743,2.743,0,0,1,14.253,15.8Zm0,4.646A11.075,11.075,0,0,1,7.729,18.4,12.5,12.5,0,0,1,3.385,13.03,12.493,12.493,0,0,1,7.734,7.667a11.4,11.4,0,0,1,13.048,0,12.493,12.493,0,0,1,4.349,5.363,12.493,12.493,0,0,1-4.349,5.363,11.075,11.075,0,0,1-6.524,2.05Zm.006-1.488a9.945,9.945,0,0,0,5.5-1.619,10.514,10.514,0,0,0,3.818-4.312,10.513,10.513,0,0,0-3.814-4.312,10.153,10.153,0,0,0-10.995,0A10.681,10.681,0,0,0,4.929,13.03a10.689,10.689,0,0,0,3.838,4.312,9.929,9.929,0,0,0,5.487,1.619Z",
    transform: "translate(1025.088 995.456)",
    fill: "#231f20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.b614314e3d945600d5d4dd53a03a4fae.svg";
export { ForwardRef as ReactComponent };